import type { SVGProps } from 'react'
const IconCalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.66 10.668a.75.75 0 0 1 .75-.75H20.45a.75.75 0 0 1 0 1.5H4.41a.75.75 0 0 1-.75-.75M16.064 2.25a.75.75 0 0 1 .75.75v2.962a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75M8.794 2.25a.75.75 0 0 1 .75.75v2.962a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.965 4.953c.919-.874 2.198-1.281 3.655-1.281h7.62c1.46 0 2.74.407 3.658 1.281.923.88 1.382 2.141 1.378 3.648v8.213c0 1.507-.461 2.77-1.384 3.65-.919.877-2.198 1.286-3.66 1.286H8.62c-1.461 0-2.742-.418-3.66-1.308-.922-.893-1.384-2.17-1.384-3.696V8.6c0-1.508.464-2.768 1.389-3.647M5.998 6.04c-.56.533-.922 1.362-.922 2.56v8.146c0 1.222.364 2.073.928 2.62.568.55 1.434.884 2.616.884h7.613c1.19 0 2.057-.33 2.623-.87.56-.535.92-1.367.92-2.566V8.598c.004-1.199-.354-2.027-.913-2.559-.564-.538-1.431-.867-2.623-.867H8.62c-1.187 0-2.055.329-2.622.868"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.951 15.502a.75.75 0 0 1 .75-.75h4.843a.75.75 0 1 1 0 1.5H11.7a.75.75 0 0 1-.75-.75M7.567 15.502a.75.75 0 0 1 .75-.75h.414a.75.75 0 1 1 0 1.5h-.414a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
)
export default IconCalendarIcon
